import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  /** Root: fills `withLayout` column; does not shrink below parent width. */
  root: {
    width: '100%',
    maxWidth: '100%',
    boxSizing: 'border-box',
    alignSelf: 'stretch',
    minWidth: 0,
  },
  outerCard: {
    width: '100%',
    maxWidth: '100%',
    boxSizing: 'border-box',
    paddingBottom: theme.spacing(2),
    /** Avoid stretching to fill viewport in flex layout (replaces former `cardSx` + Paper). */
    height: 'auto',
    minHeight: 0,
  },
  searchSection: {
    width: '100%',
    maxWidth: '100%',
    boxSizing: 'border-box',
    fontSize: theme.typography.pxToRem(24),
    padding: theme.spacing(2.5, 2, 1, 2),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(2.5, 0, 1, 0),
    },
  },
  searchBar: {
    width: '100%',
    maxWidth: '80%',
    boxSizing: 'border-box',
    [theme.breakpoints.down('md')]: {
      maxWidth: '100%',
    },
  },

  chipList: {
    width: '100%',
    maxWidth: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
      paddingTop: theme.spacing(2),
      paddingLeft: 0,
    },
  },
  letterHeader: {
    color: theme.palette.custom.red.light,
    marginBottom: theme.spacing(1),
  },
  sectionDivider: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  resultsList: {
    width: '100%',
    maxWidth: '100%',
    padding: 0,
  },
  listRegion: {
    width: '100%',
    maxWidth: '100%',
    minHeight: 320,
    boxSizing: 'border-box',
  },
  listSkeletonRoot: {
    width: '100%',
    paddingTop: theme.spacing(2),
  },
  cardSkeleton: {
    borderRadius: theme.shape.borderRadius,
  },
  alphabetSection: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(2),
  },
  gridContainer: {
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
    paddingTop: theme.spacing(2),
  },
  userCardContainer: {
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  cardContainer: {
    width: '100%',
    maxWidth: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },
  alphabetContainer: {
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    margin: theme.spacing(0, 6, 0, 1),
    padding: theme.spacing(1, 0, 2, 6),
    flexWrap: 'wrap',
  },
  letterBox: {
    height: '32px',
    width: '32px',
    padding: theme.spacing(0, 1, 0, 1),
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  letter: {
    fontSize: theme.typography.pxToRem(18),
    fontWeight: 'bold',
    '&:not(:last-child)': {
      paddingBottom: theme.spacing(4),
    },
    '&:hover': {
      color: theme.palette.custom.red.light,
      fontWeight: 'bold',
      cursor: 'pointer',
    },
    '&:disabled': {
      color: theme.palette.custom.grey.light,
    },
  },
  letterActive: {
    color: theme.palette.custom.red.light,
    borderBottom: `3px solid ${theme.palette.custom.red.light}`,
  },
  disabledLetter: {
    color: theme.palette.text.disabled,
  },
  noResultsContainer: {
    width: '100%',
    maxWidth: '100%',
    minHeight: '400px',
    boxSizing: 'border-box',
  },
  noResultsContent: {
    width: '100%',
    maxWidth: '100%',
    boxSizing: 'border-box',
  },
  noResultsIcon: {
    paddingTop: theme.spacing(2),
  },
  loadingSkeletonContainer: {
    minHeight: theme.spacing(50),
  },
  /** Full-width column inside list rows (Grid + header). */
  sectionBlock: {
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
    boxSizing: 'border-box',
  },
}));
